"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
interface ConfirmLeaveDialogProps {
  open: boolean;
  canSave: boolean;
  isSaving: boolean;
  onCancel: () => void;
  onLeave: () => void;
  onSaveAndLeave: () => void;
}
export default function ConfirmLeaveDialog(t0) {
  const $ = _c(25);
  const {
    open,
    canSave,
    isSaving,
    onCancel,
    onLeave,
    onSaveAndLeave
  } = t0;
  let t1;
  if ($[0] !== isSaving || $[1] !== onCancel) {
    t1 = nextOpen => {
      if (!nextOpen && !isSaving) {
        onCancel();
      }
    };
    $[0] = isSaving;
    $[1] = onCancel;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !isSaving;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <DialogHeader><DialogTitle>Ungespeicherte Änderungen</DialogTitle><DialogDescription>Diese Seite enthält ungespeicherte Daten. Möchtest du die Seite wirklich verlassen?</DialogDescription></DialogHeader>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isSaving || $[5] !== onCancel) {
    t4 = <Button variant="outline" onClick={onCancel} disabled={isSaving}>Abbrechen</Button>;
    $[4] = isSaving;
    $[5] = onCancel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isSaving || $[8] !== onLeave) {
    t5 = <Button variant="destructive" onClick={onLeave} disabled={isSaving}>Seite verlassen</Button>;
    $[7] = isSaving;
    $[8] = onLeave;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canSave || $[11] !== isSaving || $[12] !== onSaveAndLeave) {
    t6 = canSave && <Button onClick={onSaveAndLeave} disabled={isSaving}>{isSaving ? "Speichere\u2026" : "Speichern und verlassen"}</Button>;
    $[10] = canSave;
    $[11] = isSaving;
    $[12] = onSaveAndLeave;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <DialogFooter>{t4}{t5}{t6}</DialogFooter>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t2 || $[19] !== t7) {
    t8 = <DialogContent showCloseButton={t2}>{t3}{t7}</DialogContent>;
    $[18] = t2;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== open || $[22] !== t1 || $[23] !== t8) {
    t9 = <Dialog open={open} onOpenChange={t1}>{t8}</Dialog>;
    $[21] = open;
    $[22] = t1;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}